<template>
  <v-snackbar
    v-model="showSnackbar"
    :right="right"
    :left="!right"
    center
    multi-line
    :color="color"
    :timeout="6000"
    >{{ mensagem }}</v-snackbar
  >
</template>

<script>
export default {
  data: () => ({
    showSnackbar: false,
    mensagem: null,
    color: "primary",
    right: false
  }),
  methods: {
    mostrarMensagem(mensagem, cor, isRight) {
      this.mensagem = mensagem;
      this.color = cor;
      this.right = isRight;
      this.showSnackbar = true;
    }
  }
};
</script>
